import React from "react";
import { toArray } from "../../utils/helpers";
import "./Field.css";

export interface FieldExtraLabelsProps {
  labels: React.ReactNode | React.ReactNodeArray;
}

export default function ExtraLabels({ labels }: FieldExtraLabelsProps) {
  if (!labels) {
    return null;
  }

  return (
    <span className="extra-labels">
      {toArray(labels).map((label, index) => (
        <span key={index} className="extra-label">
          {label}
        </span>
      ))}
    </span>
  );
}
